export const COST_GROUP_TYPE = {
  EXPENSE: 1,
  MANAGEMENT: 2,
};

export const COST_GROUP_TYPE_LABEL = {
  [COST_GROUP_TYPE.EXPENSE]: 'Loại chi phí',
  [COST_GROUP_TYPE.MANAGEMENT]: 'Loại quản lý',
};
